export default __webpack_public_path__ + "static/media/audio_13_ranas.a2266d75.mp3";